mutation updateCompanyAmbassadorSignatureHTML($input: UpdateCompanyAmbassadorSignatureHTMLInput!) {
  updateCompanyAmbassadorSignatureHTML(input: $input)
}
